export default class HelperCookie {

	/**
	 * Чете cookie стойност с JS.
	 * @param cookieName име на cookie.
	 * @return string стойност на cookie.
	 */
	static getCookie(cookieName) {
		let name = cookieName + "=";
		let ca = document.cookie.split(';');

		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	/**
	 * @param cookieName име на cookie.
	 * @param cookieValue стойност на cookie.
	 * @param expireDays валидност(дни)
	 * @param cookieDomain домейн
	 *
	 */
	static setCookie(cookieName, cookieValue, expireDays, cookieDomain = '') {
		let d = new Date();

		d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));

		if (cookieDomain == '') {
			let a = window.location.hostname.split('.');
			cookieDomain = a[a.length - 2] + '.' + a[a.length - 1];
		}
		document.cookie = `${cookieName}=${cookieValue};domain=.${cookieDomain};expires=${d.toUTCString()}`;
	}
}

